export default __webpack_public_path__ + "static/media/news20.fa96956f.jpg";